import { Option } from '@common-fe/common-fe';

export enum FileType {
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  TIF = 'image/tif',
  TIFF = 'image/tiff',
}
export const SERVER_ERRORS = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  SERVER_ERROR: 500,
};
export enum FileExtension {
  PDF = '.pdf',
  JPEG = '.jpeg',
  JPG = '.jpg',
  PNG = '.png',
  HEIC = '.heic',
  HEIF = '.heif',
  TIF = '.tif',
  TIFF = '.tiff',
}

export const TRUE_KEY = 'true';
export const FALSE_KEY = 'false';
export const EMPTY_FIELD_VALUE = '—';
export const YES_KEY = 'yes';
export const NO_KEY = 'no';
export const FALSE_STRING = 'false';
export const TRUE_STRING = 'true';
export const EMPTY_WHITE_LABEL_STRING = ' ';
export const TBD_TITLE = '$TBD';

export const KEYS = {
  ENTER: 'Enter',
};
export interface FileImage {
  id: string;
  temporalId: string;
  path: string;
  preview: string;
  name: string;
  type: string;
  blob?: Blob | MediaSource;
  url?: string;
}

export const ACCEPTED_FILE_TYPES = {
  [FileType.PDF]: [FileExtension.PDF],
  [FileType.JPEG]: [FileExtension.JPEG],
  [FileType.JPG]: [FileExtension.JPG],
  [FileType.PNG]: [FileExtension.PNG],
  [FileType.HEIC]: [FileExtension.HEIC],
  [FileType.HEIF]: [FileExtension.HEIF],
  [FileType.TIF]: [FileExtension.TIF],
  [FileType.TIFF]: [FileExtension.TIFF],
};

export const MAX_SIZE_OF_FILE_IN_MEGABYTES = 20;
export const MAX_SIZE_OF_FILE = MAX_SIZE_OF_FILE_IN_MEGABYTES * 1024 * 1024;
export const REQUIRED_TEXT = 'The field is required';
export const REQUIRED_NOT_EMPTY = 'This field cannot be empty';
export const CUSTOM_DAY_ERROR_TEXT = 'This number does not match the range of available numbers (1-31)';
export const INVALID_TEXT = 'The field is invalid';
export const PHONE_NUMBER_INVALID_TEXT = 'Not a valid 10-digit US phone number';
export const EMAIL_INVALID_TEXT = 'Email must be valid';
export const DATE_INVALID_TEXT = 'Date must be valid';
export const SSN_INVALID_TEXT = 'SSN should be 9-digit number';
export const DATE_INVALID_ALTERNATIVE_TEXT = 'Invalid date';
export const DATE_INVALID_FORMAT = (dateFormat: string) => `Date format must be ${dateFormat}`;
export const CLAIM_AGREEMENT_ERROR_TEXT =
  'Please confirm the claim information submitted is accurate and complete.';
export const CLAIM_OCR_ERROR_TEXT = 'Please correct the highlighted errors to submit the claim. ';
export const CLAIM_INVALID_PAYMENT_METHOD_TEXT = 'Please select a valid payment method.';
export const PASSWORD_ERROR_MESSAGE = 'Password does not meet our minimum security criteria';
export const SPECIFIC_FIELD_REQUIRED_TEXT = (fieldName: string) => `${fieldName} is required`;
export const MAX_LENGTH_TEXT = (count: number) => `This field must be at most ${count} characters`;
export const ACCOUNTS_TYPES = {
  HSA: 'hsa',
  FSA: 'fsa',
};

export const CURRENCY_SIGN = '$';

export const FIRST_DAY_NUMBER = '01';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const SHORT_DATE_FORMAT = 'MM/DD/YY';
export const DATE_OF_MONTH_FORMAT = 'MMM DD';
export const ONLY_MONTH_NAME_FORMAT = 'MMM';
export const TEXT_DATE_FORMAT = 'MMM DD, YYYY';
export const FULL_MONTH_DATE_FORMAT = 'MMMM DD, YYYY';
export const ONLY_MONTH_DATE_FORMAT = 'MMMM, YYYY';
export const DEFAULT_TIME_FORMAT = 'HH:MM a';
export const DEFAULT_CARD_EXP_DATE_FORMAT = 'MM/DD/YY';
export const RAW_DATE_FORMAT = 'YYYY-MM-DD';
export const DEBIT_EXP_DATE_FORMAT = 'YYYY-MM-DD';
export const FULL_DATE_TIME_FORMATE = 'hh:mm A MMMM DD YYYY';
export const DATE_TOOLTIP_FORMAT = 'D MMMM YYYY';
export const DATE_MONTH_YEAR_FORMAT = 'MM/YY';
export const MINUTES_WITH_SECONDS_FORMAT = 'mm:ss';
export const MOUNTH_YEAR_FORMAT = 'MMM YYYY';

export const MINUTE = 60000;
export const SECOND = 1000;
export const DEFAULT_EMPTY_CHARACTER = '—';
export const DAYS_OF_DISABLED_REQUESTS = 7;
export const TWENTIETH_CENTURY = 20;
export const COOKIE_NEVER_EXPIRE = 10 * 365 * 24 * 60 * 60;

export const INVESTMENTS_ERROR_KEY = {
  EMTPY_AMOUNT_ERROR: 'Enter the funding amount',
  AMOUNT_MORE_THAN_ZERO_ERROR: 'Invested amount should be more than $0.00',
  AGREEMENT_ERROR_TEXT: 'Please confirm that you acknowledge and accept all the listed disclosures.',
  INVESTMENT_PATH_ERROR_TEXT: 'Please select your Investment path option',
  NOT_ANSWER_ALL_QUESTIONS_ERROR: 'You have to answer all questions',
  MINIMUM_HSA_BALANCE: 'Minimum HSA balance to invest is',
};

export const AUTH_ERROR_KEY = {
  WRONG_SSN_OR_DATE:
    'Server cannot process request for specified url. Details: Search criteria common cannot be processed for the passed arguments.',
  PHONE_NUMBER: 'Invalid phone number.',
  USERNAME_WORNG_FORMATE: '1000002',
  ACCOUNT_EXIST: 'Details: Application user with ',
  AUTH_ERROR: 'Authorization has failed or has not yet been provided.',
  AUTH_SECOND_ERROR: 'Authentication has failed or has not yet been provided.',
  CODE_IS_WRONG: 'The code is wrong',
  PASSWORD_MUST_MATCH: 'Passwords must match',
  PASSWORD_IS_REQUIRED: 'Password is required',
  USER_NAME_REQUIRED: 'Username is required',
  USER_FORMAT_INVALID: 'Username format is invalid',
  PASSWORD_DO_NOT_MATCH: 'Passwords do not match. Please make sure both passwords are identical.',
  PASSWORD_INVALID: 'Password is not valid',
  PASSWORD_MUST_BE_DIFFERENT: 'New password must be different from the existing password.',
  PASSWORD_TOO_SHORT: 'At least 8 characters',
  MIXTURE_UPPER_AND_LOWER_CASE: 'A mixture of both uppercase and lowercase letters',
  MIXTURE_LETTERS_AND_NUMBERS: 'A mixture of letters and numbers',
  INCLUSION_ONE_SPECIAL_CHARACTER: 'Inclusion of at least one special character, e.g., !, @, #',
  DOES_NOT_CONTAIN_FORBIDDEN_CHARACTERS: 'Must not contain prohibited characters, e.g., +, _',
  START_OR_END_WITH_SPACE: 'Your password cannot begin or end with a blank space',
  TOO_MANY_FAILED_ATTEMPTS: 'Too many failed attempts. Please try again in a few minutes',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Please try again in a few minutes',
};

export const US_STATES = [
  { key: 'Alabama', value: 'Alabama' },
  { key: 'Alaska', value: 'Alaska' },
  { key: 'Arizona', value: 'Arizona' },
  { key: 'Arkansas', value: 'Arkansas' },
  { key: 'California', value: 'California' },
  { key: 'Colorado', value: 'Colorado' },
  { key: 'Connecticut', value: 'Connecticut' },
  { key: 'Delaware', value: 'Delaware' },
  { key: 'District of Columbia', value: 'District of Columbia' },
  { key: 'Florida', value: 'Florida' },
  { key: 'Georgia', value: 'Georgia' },
  { key: 'Hawaii', value: 'Hawaii' },
  { key: 'Idaho', value: 'Idaho' },
  { key: 'Illinois', value: 'Illinois' },
  { key: 'Indiana', value: 'Indiana' },
  { key: 'Iowa', value: 'Iowa' },
  { key: 'Kansas', value: 'Kansas' },
  { key: 'Kentucky', value: 'Kentucky' },
  { key: 'Louisiana', value: 'Louisiana' },
  { key: 'Maine', value: 'Maine' },
  { key: 'Maryland', value: 'Maryland' },
  { key: 'Massachusetts', value: 'Massachusetts' },
  { key: 'Michigan', value: 'Michigan' },
  { key: 'Minnesota', value: 'Minnesota' },
  { key: 'Mississippi', value: 'Mississippi' },
  { key: 'Missouri', value: 'Missouri' },
  { key: 'Montana', value: 'Montana' },
  { key: 'Nebraska', value: 'Nebraska' },
  { key: 'Nevada', value: 'Nevada' },
  { key: 'New Hampshire', value: 'New Hampshire' },
  { key: 'New Jersey', value: 'New Jersey' },
  { key: 'New Mexico', value: 'New Mexico' },
  { key: 'New York', value: 'New York' },
  { key: 'North Carolina', value: 'North Carolina' },
  { key: 'North Dakota', value: 'North Dakota' },
  { key: 'Ohio', value: 'Ohio' },
  { key: 'Oklahoma', value: 'Oklahoma' },
  { key: 'Oregon', value: 'Oregon' },
  { key: 'Pennsylvania', value: 'Pennsylvania' },
  { key: 'Rhode Island', value: 'Rhode Island' },
  { key: 'South Carolina', value: 'South Carolina' },
  { key: 'South Dakota', value: 'South Dakota' },
  { key: 'Tennessee', value: 'Tennessee' },
  { key: 'Texas', value: 'Texas' },
  { key: 'Utah', value: 'Utah' },
  { key: 'Vermont', value: 'Vermont' },
  { key: 'Virginia', value: 'Virginia' },
  { key: 'Washington', value: 'Washington' },
  { key: 'West Virginia', value: 'West Virginia' },
];

export enum Roles {
  employee = 'EMPLOYEE',
  employeeLimitedAccess = 'EMPLOYEE_LIMITED_ACCESS',
  noAccess = 'NO_ACCESS',
}

export const AVAILABLE_ROLES = [Roles.employee, Roles.employeeLimitedAccess];

export enum OrganizationTypes {
  company = 'COMPANY',
  partner = 'PARTNER',
  system = 'SYSTEM',
  employee = 'EMPLOYEE',
  employer = 'EMPLOYER',
  distributor = 'DISTRIBUTOR',
  dependent = 'DEPENDENT',
  subsidiary = 'SUBSIDIARY',
  subgroup = 'SUBGROUP',
}

export enum RiskControlOptions {
  CONSERVATIVE = 'CONSERVATIVE',
  MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
  MODERATE = 'MODERATE',
  MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
  AGGRESSIVE = 'AGGRESSIVE',
}

export enum CommunicationChannels {
  NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
  EMAIL_SMS = 'EMAIL_SMS',
}

export enum HsaCustodianType {
  UMB = 'UMB',
  NONE = 'None',
}

export enum StockQuoteType {
  VTSMX = 'VTSMX',
  VRIF = 'VRIF',
  SPDR = 'SPDR',
  SCHD = 'SCHD',
  TSLA = 'TSLA',
}

export enum BuySellOptions {
  INVEST_MORE_FUNDS = 'Invest more Funds',
  INVESTMENTS_TO_CASH = 'Investments to Cash',
}

export enum Breakpoints {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const COUNTRY_MAP: { [key: number]: string } = {
  1: 'USA',
};
export const ALL_KEY = 'Null';
export const ALL_OPTION_KEY = ALL_KEY;
export const ALL_OPTION = {
  key: ALL_KEY,
  value: 'Null',
  title: 'All',
};

export const LOGO_SIZE = '40px';
export const FAV_SIZE = '16px';

export enum LetterIconSizeEnum {
  LOGO = 'logo',
  FAV = 'fav',
}

export const LARGE_SIZE_LOGO = {
  width: 120,
  height: 40,
};

export enum RequestHeaders {
  preferredEmployeeId = 'Preferred-Employee-Id',
}

export enum UploadFileByQrLinkParamKey {
  QR_ID = 'qr_id',
  EMPLOYEE_ID = 'employee_id',
  VALID_TO = 'valid_to',
  DOCUMENT_ID = 'document_id',
  DOCUMENT_TYPE = 'document_type',
}

export enum PartnerMobileAppType {
  NONE = 'NONE',
  ELEVATE_APP = 'ELEVATE_APP',
  PARTNER_OWN_APP = 'PARTNER_OWN_APP',
}

export enum ExternalLink {
  termsAndCondition = 'https://www.elevate.inc/terms-of-use',
  privacyPolicy = 'https://www.elevate.inc/privacy-policy',
  ripplingLogin = 'https://app.rippling.com/hsa-benefits/employee/dashboard ',
  gustoProdLogin = 'https://app.gusto.com/login',
  gustoDemoLogin = 'https://app.gusto-demo.com/',
}

export enum DismissedBannerKey {
  USE_MY_MONEY_SEE_WHATS_NEW = 'use-my-money-see-whats-new',
}

export const SORT_OPTIONS: Option[] = [
  {
    key: 'ASC',
    value: 'Ascending',
  },
  {
    key: 'DESC',
    value: 'Descending',
  },
];

export enum ClientType {
  WEB_APP = 'WEB_APP',
}

export enum PromiseStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

export const LINKED_EMPLOYEE_STORAGE_KEY = 'LinkedEmployeeStorageKey';
